<template>
  <div>
    <self-payment-dialog
      :dialog="selfPayment"
      :id="selfPaymentId"
      @close="selfPayment = false"
      :memberIdentityId="memberIdentityId"
    />
    <credit-hours-dialog
      :dialog="creditHours"
      :planEntryDate="planEntryDate"
      :memberName="memberName"
      :item="creditHoursData"
      @close="creditHours = false"
      @save="tryCreditHours"
      :loading="saving"
    />
    <transfer-out-dialog
      :dialog="transferOut"
      :planEntryDate="planEntryDate"
      :memberName="memberName"
      :item="transferOutData"
      @close="transferOut = false"
      @save="tryTransferOut"
      :loading="saving"
    />
    <transfer-in-dialog
      :dialog="transferIn"
      :planEntryDate="planEntryDate"
      :memberName="memberName"
      :item="transferInData"
      @close="transferIn = false"
      @save="tryTransferIn"
      :loading="saving"
    />
    <rebalance-dialog
      :dialog="rebalance"
      :planEntryDate="planEntryDate"
      :memberName="memberName"
      :item="rebalanceData"
      @close="rebalance = false"
      @save="tryRebalance"
      :loading="saving"
    />
    <reevaluation-dialog
      :dialog="reevaluate"
      :planEntryDate="planEntryDate"
      :memberName="memberName"
      :item="reevaluateData"
      @close="reevaluate = false"
      @save="tryReevaluate"
      :loading="saving"
    />
    <pbas-data-table
      v-if="provider"
      :exporters="$exporters"
      ref="table"
      :dataProvider="provider"
      fileNamePrefix="eligibility_bank"
      :identifier="'eligibility_bank_table' + selectedPlan.Id"
      @error="error = $event"
      :showSelect="false"
      :canExpand="(item) => true"
      :showExpand="true"
      :generateProviderForExpanded="
        (item) => generateTransactionsProvider(item)
      "
      :floatActions="floatActions"
      @itemsChanged="setActions"
      :expandedRowActions="rowActions"
      :sortBy="'CalendarYear'"
      :sortDescending="true"
    ></pbas-data-table>
    <v-container fluid grid-list-md v-else>
      <v-layout row justify-center>
        <v-flex xs12 sm6 md4 lg3>
          <v-progress-circular indeterminate></v-progress-circular>
        </v-flex>
      </v-layout>
    </v-container>
    <error-handler :error="error"></error-handler>
    <v-snackbar v-model="snackbar" :color="color" :timeout="timeout">
      {{ $t(message) }}
      <v-btn dark text @click="snackbar = false">
        {{ $t("globals.close") }}
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ODataProvider, ODataHeader, ODataString } from "pbas-vue-components";
import EligibilityBankHeaders from "@/headers/EligibilityBank";
import ErrorHandler from "@/components/ErrorHandler";
import getTransactionsHeaders from "@/headers/EligibilityBankTransactions";
import CreditHoursDialog from "@/components/MemberView/EligibilityBank/CreditHoursDialog.vue";
import TransferOutDialog from "@/components/MemberView/EligibilityBank/TransferOutDialog.vue";
import ReevaluationDialog from "@/components/MemberView/EligibilityBank/ReevaluationDialog.vue";
import TransferInDialog from "@/components/MemberView/EligibilityBank/TransferInDialog.vue";
import SelfPaymentDialog from "@/components/MemberView/EligibilityBank/SelfPaymentDialog.vue"
import Eligibility from "../../../views/Eligibility.vue";
import RebalanceDialog from "@/components/MemberView/EligibilityBank/RebalanceDialog.vue";

export default {
  props: [
    "memberIdentityId",
    "eligibilityBankId",
    "memberName",
    "planEntryDate",
    "isEligible",
  ],
  components: {
    ErrorHandler,
    CreditHoursDialog,
    TransferOutDialog,
    ReevaluationDialog,
    TransferInDialog,
    SelfPaymentDialog,
    RebalanceDialog
  },
  data() {
    return {
      saving: false,
      provider: null,
      error: null,
      creditHours: false,
      creditHoursData: {},
      transferOut: false,
      transferOutData: {},
      transferIn: false,
      transferInData: {},
      reevaluate: false,
      reevaluateData: {},
      floatActions: [],
      completedEvaluations: [],
      snackbar: false,
      color: "success",
      timeout: 3500,
      message: "",
      rowActions: [
        {
          name: "selfPayment",
          icon: "attach_money",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            console.log(item.SelfPaymentId);
            this.selfPaymentId = item.SelfPaymentId;
            this.selfPayment = true;
          },
          visible: (item) => item.SelfPaymentId !== undefined && item.SelfPaymentId !== null
        },
      ],
      selfPayment: false,
      selfPaymentId: null,
      rebalance: false,
      rebalanceData:{}
    };
  },
  methods: {
    ...mapActions("plansMembers", [
      "eligibilityBankCreditHoursMember",
      "eligibilityBankTransferOutMember",
      "eligibilityBankTransferInMember",
      "eligibilityBankReevaluateMember",
      "getBlobAsync",
      "getEligibilityBankCompletedEvaluations",
      "eligibilityBankRebalanceMember"
    ]),
    setActions(items) {
      let floatActions = [];
      if (this.isEligible) {
        floatActions.push({
          text: "components.memberview.transfer_out",
          color: this.$vuetify.theme.themes.light.warning,
          name: "transferOut",
          icon: "remove",
          handler: this.transferOutHandler,
        });
      }
      if (items.length === 0) {
        floatActions.push({
          text: "components.memberview.transfer_in",
          color: this.$vuetify.theme.themes.light.success,
          name: "transferIn",
          icon: "add",
          handler: this.transferInHandler,
        });
      }
      floatActions.push({
          text: "components.memberview.credit_hours",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: this.creditHoursHandler,
        });
      if (this.completedEvaluations) {
        floatActions.push({
          text: "components.memberview.reevaluate",
          color: this.$vuetify.theme.themes.light.success,
          name: "reevaluate",
          icon: "change_circle",
          handler: this.reevaluateHandler,
        });
      }
      // floatActions.push({
      //     text: "enums.Rebalance",
      //     color: this.$vuetify.theme.themes.light.success,
      //     name: "rebalance",
      //     icon: "balance",
      //     handler: this.rebalanceHandler,
      //   });
      this.floatActions = floatActions;
    },
    async loadData() {
      let headers = EligibilityBankHeaders;
      // headers.push(
      //   new ODataHeader({
      //     title: "enums.SelfPayment",
      //     type: new ODataString("SelfPaymentId", {
      //       getString: (item, type) => {
      //         return this.$t("enums.SelfPayment");
      //       },
      //       getHtml: (item, type) => {
      //         return `<a href="#" target="_blank" onclick="${(e)=>this.linkToSelfPayment(e)}">${type.getString(
      //           item,
      //           type
      //         )}</a>`;
      //       },
      //     }),
      //     sortable: true,
      //     visible: true,
      //     searchable: true,
      //   })
      // );
      if (this.memberIdentityId) {
        const url = `/plans/${this.selectedPlan.Id}/members/${this.memberIdentityId}/eligibility-bank-history/${this.eligibilityBankId}`;
        this.provider = new ODataProvider(this.$axiosHttp, url, headers);
      }
      if (this.isEligible) {
        this.floatActions.push({
          text: "components.memberview.transfer_out",
          color: this.$vuetify.theme.themes.light.warning,
          name: "transferOut",
          icon: "remove",
          handler: this.transferOutHandler,
        });
        this.floatActions.push({
          text: "components.memberview.credit_hours",
          color: this.$vuetify.theme.themes.light.success,
          name: "add",
          icon: "add",
          handler: this.creditHoursHandler,
        });
      }
      this.completedEvaluations = this.getEligibilityBankCompletedEvaluations({
        planIdentityId: this.selectedPlan.Id,
        memberIdentityId: this.memberIdentityId,
      }).data.value;

      if (this.completedEvaluations.length > 0) {
        this.floatActions.push({
          text: "components.memberview.reevaluate",
          color: this.$vuetify.theme.themes.light.success,
          name: "reevaluate",
          icon: "change_circle",
          handler: this.reevaluateHandler,
        });
      }
      console.log("mounted: ", this.planEntryDate);
    },
    reload() {
      if (this.$refs.table) {
        this.$refs.table.getDataAsync();
      }
    },
    generateTransactionsProvider(item) {
      const headers = getTransactionsHeaders(this.options.Enums);
      const url = `/plans/${this.selectedPlan.Id}/members/${this.memberIdentityId}/eligibility-bank-transactions/${this.eligibilityBankId}/${item.CalendarYear}/${item.CalendarMonth}`;
      const p = new ODataProvider(this.$axiosHttp, url, headers);
      return p;
    },
    creditHoursHandler() {
      this.creditHoursData = {
        // "Amount": 0.0,
        // "CalendarMonth": 0,
        // "CalendarYear": 0,
        MemberIdentityId: this.memberIdentityId,
        PlanIdentityId: this.selectedPlan.Id,
      };
      this.creditHours = true;
    },
    transferOutHandler() {
      this.transferOutData = {
        TransferOutDate: null,
      };
      this.transferOut = true;
    },
    rebalanceHandler() {
      this.rebalanceData = {
        CalendarMonth: null,
        CalendarYear: null,
        MemberIdentityId: this.memberIdentityId,
        PlanIdentityId: this.selectedPlan.Id
      };
      this.rebalance = true;
    },
    transferInHandler() {
      this.transferInData = {
        CalendarMonth: null,
        CalendarYear: null,
        Amount: null,
        MemberIdentityId: this.memberIdentityId,
        PlanIdentityId: this.selectedPlan.Id,
        AsEligible: false,
      };
      this.transferIn = true;
    },
    reevaluateHandler() {
      this.reevaluateData = {
        CalendarYear: null,
        CalendarMonth: null,
      };
      this.reevaluate = true;
    },
    evaluateHandler() {
      this.evaluateData = {
        CalendarYear: null,
        CalendarMonth: null,
      };
      this.evaluate = true;
    },
    async tryCreditHours() {
      try {
        console.log(this.creditHoursData);
        let data = JSON.parse(JSON.stringify(this.creditHoursData));
        data.CalendarMonth =
          this.options.Enums.Month.indexOf(this.creditHoursData.CalendarMonth) +
          1;
        this.saving = true;
        await this.eligibilityBankCreditHoursMember({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          payload: data,
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.creditHours = false;
        this.$emit("reload");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    async tryTransferOut() {
      try {
        console.log(this.transferOutData);
        let data = JSON.parse(JSON.stringify(this.transferOutData));
        this.saving = true;
        const [date, time] = data.TransferOutDate.split("T");
        const [year, month, day] = date.split("-");
        let dateFormatted = `${year}-${month}-${day}T00:00:00.000Z`;
        const url = `plans/${this.selectedPlan.Id}/members/${this.memberIdentityId}/transfer-out/${dateFormatted}`;

        console.log(url); // Log the URL to verify

        let response = await this.getBlobAsync({ url: url });
        let blob = response.data;

        console.log(blob); // Log the blob to verify

        const url2 = window.URL.createObjectURL(
          new Blob([blob], { type: "text/csv" })
        );
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", "transfer-out.csv");
        link.setAttribute("id", "link1");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.transferOut = false;
        this.$emit("reload");
      } catch (error) {
        this.error = error;
        console.error("Error downloading the file", error);
      } finally {
        this.saving = false;
      }
    },
    async tryTransferIn() {
      try {
        console.log(this.transferInData);
        let data = JSON.parse(JSON.stringify(this.transferInData));
        data.CalendarMonth =
          this.options.Enums.Month.indexOf(this.transferInData.CalendarMonth) +
          1;
        this.saving = true;
        await this.eligibilityBankTransferInMember({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          payload: data,
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.transferIn = false;
        this.$emit("reload");
      } catch (error) {
        if (
          error.response &&
          error.response.status === 409 &&
          error.response.data.Code === 9003
        ) {
          this.color = "warning";
          this.message = this.$t(
            "views.eligibility_bank.tranfer_in_as_eligible_warning"
          );
          this.snackbar = true;
          this.transferIn = false;
          this.$emit("reload");
        } else {
          this.error = error;
        }
      } finally {
        this.saving = false;
      }
    },
    async tryRebalance() {
      try {
        console.log(this.rebalanceData);
        let data = JSON.parse(JSON.stringify(this.rebalanceData));
        data.CalendarMonth =
          this.options.Enums.Month.indexOf(this.rebalanceData.CalendarMonth) +
          1;
        this.saving = true;
        await this.eligibilityBankRebalanceMember({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          payload: data,
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.rebalance = false;
        this.$emit("reload");
      } catch (error) {
        // if (
        //   error.response &&
        //   error.response.status === 409 &&
        //   error.response.data.Code === 9003
        // ) {
        //   this.color = "warning";
        //   this.message = this.$t(
        //     "views.eligibility_bank.tranfer_in_as_eligible_warning"
        //   );
        //   this.snackbar = true;
        //   this.transferIn = false;
        //   this.$emit("reload");
        // } else {
          this.error = error;
        // }
      } finally {
        this.saving = false;
      }
    },
    async tryReevaluate() {
      try {
        console.log(this.reevaluateData);
        let data = JSON.parse(JSON.stringify(this.reevaluateData));
        data.CalendarMonth =
          this.options.Enums.Month.indexOf(this.reevaluateData.CalendarMonth) +
          1;
        this.saving = true;
        await this.eligibilityBankReevaluateMember({
          planIdentityId: this.selectedPlan.Id,
          memberIdentityId: this.memberIdentityId,
          calendarYear: data.CalendarYear,
          calendarMonth: data.CalendarMonth,
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.reevaluate = false;
        this.$emit("reload");
      } catch (error) {
        this.error = error;
      } finally {
        this.saving = false;
      }
    },
    linkToSelfPayment(e) {
      console.log("linkToSelfPayment: ", e)
    }
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    memberIdentityId: {
      handler: function () {
        if (this.provider === null || this.provider === undefined) {
          this.loadData();
        }
      },
    },
  },
  mounted() {
    if (this.memberIdentityId !== null && this.memberIdentityId !== undefined) {
      this.loadData();
    }
  },
};
</script>
